const ROOT = "collapsible-list-component";
const INSERT_COLLAPSIBLE_LIST_BUTTON = "collapsible-list-insert-button";
const NEW_PAIR_BUTTON = "collapsible-list-new-pair-button";
const COLLAPSIBLE_LIST_ITEM = "collapsible-list-item";
const COLLAPSIBLE_LIST_ITEM_TITLE = "collapsible-list-item-title";
const COLLAPSIBLE_LIST_ITEM_BODY = "collapsible-list-item-body";
const EXPAND_BUTTON = "collapsible-list-expand-button";
const SETTINGS_MODAL = "collapsible-list-settings-modal";
const SETTINGS_EXPAND_ONLY_ONE_TOGGLE = "settings-expand-only-one-toggle";
const SETTINGS_INITIAL_EXPANDED = "settings-initial-expanded";
const SETTINGS_INITIAL_EXPANDED_ALL = "settings-initial-expanded-all";
const SETTINGS_INITIAL_EXPANDED_FIRST = "settings-initial-expanded-first";
const SETTINGS_INITIAL_EXPANDED_NONE = "settings-initial-expanded-none";
const SETTINGS_DIRECTION = "settings-direction";
const SETTINGS_DIRECTION_LTR = "settings-ltr-direction";
const SETTINGS_DIRECTION_RTL = "settings-rtl-direction";
const SETTINGS_IS_QA_PAGE_TOGGLE = "settings-is-qapage-data-toggle";
export {
  COLLAPSIBLE_LIST_ITEM,
  COLLAPSIBLE_LIST_ITEM_BODY,
  COLLAPSIBLE_LIST_ITEM_TITLE,
  EXPAND_BUTTON,
  INSERT_COLLAPSIBLE_LIST_BUTTON,
  NEW_PAIR_BUTTON,
  ROOT,
  SETTINGS_DIRECTION,
  SETTINGS_DIRECTION_LTR,
  SETTINGS_DIRECTION_RTL,
  SETTINGS_EXPAND_ONLY_ONE_TOGGLE,
  SETTINGS_INITIAL_EXPANDED,
  SETTINGS_INITIAL_EXPANDED_ALL,
  SETTINGS_INITIAL_EXPANDED_FIRST,
  SETTINGS_INITIAL_EXPANDED_NONE,
  SETTINGS_IS_QA_PAGE_TOGGLE,
  SETTINGS_MODAL
};
//# sourceMappingURL=data-hooks.js.map
